var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { deserialize, withDefault } from '../../../../utils/serializr/serializr';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
export class TimeRange {
    type = 'timerange';
    parent;
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get ply() {
        return this.parent;
    }
    get vid() {
        return this.ply;
    }
    markStartTime;
    markEndTime;
    markName;
    static fromSerialized(ser = {}) {
        return deserialize(TimeRange, ser);
    }
    get playingMedFileIntents() {
        return this.ply.context.app.mediaPlayer.playerIntents.playingIntents.filter(intent => intent.medFile === this.ply);
    }
    get isTimeRangeActive() {
        return !!this.playingMedFileIntents.find(intent => intent.progressInSeconds * 1000 >= this.markStartTime - 300 && intent.progressInSeconds * 1000 <= this.markEndTime);
    }
    get isTimeRangeMutingRecognition() {
        if (this.markName !== 'mute_recognition')
            return false;
        return !!this.playingMedFileIntents.find(intent => intent.progressInSeconds * 1000 >= this.markStartTime - 300 && intent.progressInSeconds * 1000 <= this.markEndTime - 100);
    }
    static get serializeInfo() {
        return {
            props: {
                markStartTime: withDefault(primitive, 0),
                markEndTime: withDefault(primitive, 1000),
                markName: withDefault(primitive, 'mute_recognition'),
            },
        };
    }
}
__decorate([
    editable()
], TimeRange.prototype, "markStartTime", void 0);
__decorate([
    editable()
], TimeRange.prototype, "markEndTime", void 0);
__decorate([
    editable()
], TimeRange.prototype, "markName", void 0);
__decorate([
    sortedSet
], TimeRange.prototype, "playingMedFileIntents", null);
__decorate([
    computed
], TimeRange.prototype, "isTimeRangeActive", null);
__decorate([
    computed
], TimeRange.prototype, "isTimeRangeMutingRecognition", null);
__decorate([
    memoize
], TimeRange, "serializeInfo", null);
